{
  "name": "gdpr-portal",
  "version": "0.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "cross-env ENVIRONMENT=production ng build --configuration $ENVIRONMENT",
    "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools",
    "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
    "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
    "prepare": "husky install",
    "prettier": "npx prettier --write ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.1",
    "@angular/common": "^20.3.1",
    "@angular/compiler": "^20.3.1",
    "@angular/core": "^20.3.1",
    "@angular/forms": "^20.3.1",
    "@angular/platform-browser": "^20.3.1",
    "@angular/platform-browser-dynamic": "^20.3.1",
    "@angular/router": "^20.3.1",
    "@ctrl/ngx-emoji-mart": "^7.1.0",
    "@fortawesome/fontawesome-free": "^6.5.2",
    "@microsoft/applicationinsights-web": "^2.8.18",
    "@ngx-translate/core": "^15.0.0",
    "angular2-notifications": "^16.0.1",
    "core-js": "^3.37.1",
    "intl-tel-input": "^25.11.2",
    "ngx-bootstrap": "^18.0.0",
    "ngx-cookie": "^6.0.1",
    "ngx-translate-multi-http-loader": "^18.2.0",
    "ngx-youtube": "^1.1.0",
    "rxjs": "^6.6.7",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.5.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.2",
    "@angular-eslint/builder": "^18.1.0",
    "@angular-eslint/eslint-plugin": "^18.1.0",
    "@angular-eslint/eslint-plugin-template": "^18.1.0",
    "@angular-eslint/schematics": "^18.1.0",
    "@angular-eslint/template-parser": "^18.1.0",
    "@angular/cli": "^20.3.2",
    "@angular/compiler-cli": "^20.3.1",
    "@types/jasmine": "~3.6.0",
    "@typescript-eslint/eslint-plugin": "^7.16.0",
    "@typescript-eslint/parser": "^7.16.0",
    "@vendure/ngx-translate-extract": "^9.4.0",
    "cross-env": "^7.0.3",
    "eslint": "^8.37.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.7.0",
    "eslint-plugin-prettier": "^5.1.3",
    "husky": "^8.0.3",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "prettier": "3.3.3",
    "prettier-eslint": "^16.3.0",
    "protractor": "^7.0.0",
    "ts-node": "~4.1.0",
    "typescript": "~5.8.3"
  }
}
